
export default {
    name: 'SideEffectLink',
    props: {
        to: String,
        trackingEventName: String,
        trackingProperties: Object,
        rel: String,
    },
    computed: {
        isExternalLink() {
            return this.to.includes('http');
        },
    },
    methods: {
        onClick(event) {
            this.$emit('click');

            if (this.trackingEventName) {
                this.$analytics.trackEvent(this.trackingEventName, this.trackingProperties);
            }

            if (!this.isExternalLink) {
                this.$router.push(this.to);
                event.preventDefault();
            }
        },
    },
};
